import styled, { css } from 'styled-components';

const Container = styled.div.withConfig({
    displayName: "styles__Container",
    componentId: "sc-9442f760-0"
})`
    ${({ disabled  })=>disabled && css`
            opacity: 0.6;
            pointer-events: none;
        `}
`;
const RadioInput = styled.input.withConfig({
    displayName: "styles__RadioInput",
    componentId: "sc-9442f760-1"
})`
    height: 0;
    width: 0;
    position: absolute;

    &:checked ~ div:after {
        position: absolute;
        content: '';
        width: 10px;
        height: 10px;
        background: ${({ theme , dotColor  })=>dotColor || theme.colors.Foreground};
        border-radius: 50%;
    }
`;
const Dot = styled.div.withConfig({
    displayName: "styles__Dot",
    componentId: "sc-9442f760-2"
})`
    position: relative;
    border: 1px solid
        ${({ theme , borderColor  })=>borderColor || theme.colors["Level 2"]};
    box-sizing: border-box;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
`;
const Label = styled.label.withConfig({
    displayName: "styles__Label",
    componentId: "sc-9442f760-3"
})`
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
`;
const Text = styled.p.withConfig({
    displayName: "styles__Text",
    componentId: "sc-9442f760-4"
})`
    ${(props)=>css(props.theme.typography.Paragraph)};
    margin-left: 8px;
`;

export { Container, Dot, Label, RadioInput, Text };
